import { hideCatalogPicker } from '../State/showCatalogPicker';

export default () => (dispatch) => {
    dispatch(hideCatalogPicker());
}
